import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

const DEFAULT_AVATAR_BG = "#307da1";

const AVATAR_BG_PRESETS = [
    "#307da1",
    "#4a5568",
    "#1a3c34",
    "#5b4b8a",
    "#c27803",
    "#b42318",
];

const isAvatarBg = (value) => /^#[0-9a-fA-F]{6}$/.test(String(value || ""));

const useSettingsStore = create(
    devtools(
        persist((set) => ({
            avatarBg: DEFAULT_AVATAR_BG,
            avatarUrl: "",
            avatarKey: "",
            setAvatarBg: (value) => {
                if (!isAvatarBg(value)) return;
                set({ avatarBg: String(value).toLowerCase() });
            },
            setAvatar: ({ url = "", key = "" } = {}) => set({
                avatarUrl: String(url || ""),
                avatarKey: String(key || ""),
            }),
        }), {
            name: "settings-storage",
            partialize: (state) => ({
                avatarBg: state.avatarBg,
                avatarKey: state.avatarKey,
            }),
        }),
    ),
);

export {
    DEFAULT_AVATAR_BG,
    AVATAR_BG_PRESETS,
    isAvatarBg,
    useSettingsStore,
};
